import { PercentPipe } from '@techrules/pipelib';
import { AfterContentInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';

import { DeviceDetectorService, PortfolioDistibutionDataInterface } from '@techrules/portallib';
import { CommonService } from '@tech-services/common.service';
import * as Highcharts from 'highcharts';

import { SessionService } from '@tech-services/session.service';
import { Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';
import { AppConfig } from '@tech-utils/app-config.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'tech-portfolio-compositions',
  templateUrl: './portfolio-compositions.component.html',
  styleUrls: ['./portfolio-compositions.component.scss', '../portfolio-data-shared-styles.scss'],
})
export class PortfolioCompositionsComponent implements OnInit, AfterContentInit, OnDestroy  {
  private unsubscribe$ = new Subject<void>();
  private options: any;
  public isLoadGrafCat: boolean;
  public isLoadGrafAssetType: boolean;
  public isLoadGrafCurrency: boolean;
  public grafCatLegend: SafeHtml;
  public grafAssetTypeLegend: SafeHtml;
  public grafCurrencyLegend: SafeHtml;
  isMobile: boolean;
  constructor(
    private commonService: CommonService,
    private sessionService: SessionService,
    private profilePortfolioService: ProfileportfolioService,
    private percentPipe: PercentPipe,
    private sanitizer: DomSanitizer,
    private deviceService: DeviceDetectorService
  ) {}

  @HostListener('window:resize') onresize() {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    if (this.commonService.isProductiveSource.getValue()) {
      this.isLoadGrafCat = true;
      this.isLoadGrafAssetType = true;
      this.isLoadGrafCurrency = true;
      this.commonService.portfolioCode$
        .pipe(
          skip(1), // Ignores the first emission (on subscription)
          takeUntil(this.unsubscribe$)
        )
        .subscribe((res) => {
          this.loadDsitribution(res);
        });

      this.profilePortfolioService.periodSelected$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          this.loadDsitribution(
            this.commonService.portfolioCodeSource.getValue()
          );
        });
    }
  }

  ngAfterContentInit() {}
  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  private loadDsitribution(portfolioCode: string) {
     if (
       this.profilePortfolioService.periodSelectedSource.getValue().PeriodInitialtDate != undefined &&
       this.profilePortfolioService.periodSelectedSource.getValue().PeriodEndDate != undefined
     ) {
       let jsonPortfolioAnalysis =
         '{"PortfolioCode":"' +
         portfolioCode +
         '", ' +
         '"InitialDate": "' +
         this.profilePortfolioService.periodSelectedSource.getValue()
           .PeriodInitialtDate +
         '",' +
         '"EndDate": "' +
         this.profilePortfolioService.periodSelectedSource.getValue()
           .PeriodEndDate +
         '",' +
         '"BenchmarkCodes": [], "Type": "Composition"}';
       this.profilePortfolioService
         .getPortfolioAnalysis(jsonPortfolioAnalysis)
         .pipe(takeUntil(this.unsubscribe$))
         .subscribe((result) => {
           this.loadGrafDistrib(result.AssetClassDistrib, 'grafCat');
           this.loadGrafDistrib(result.AssetTypeDistrib, 'grafAssetType');
           this.loadGrafDistrib(result.CurrencyDistrib, 'grafCurrency');
         });
     }
  }

  private loadGrafDistrib(
    data: PortfolioDistibutionDataInterface[],
    graf: string
  ) {
    let seriesOK = [];
    data.forEach((val) => {
      let serie = {
        name: val.Name,
        data: [val.Weight],
        percentage: this.percentPipe.transform(val.Weight),
        color: val.ColorHex,
      };
      if (val.Weight > 0.0001) seriesOK.push(serie);
    });
    this.options = {
      colors: this.commonService.colorGrafic,
      chart: {
        type: 'bar',
        style: {
          fontFamily: AppConfig.cssVars.fontBase,
        },
      },
      credits: {
        //Para quitar la publi de la web del plugin
        enabled: false,
      },
      title: {
        text: ' ',
      },
      xAxis: {
        visible: false,
        tickLength: 0,
      },
      yAxis: {
        title: false,
        reversedStacks: false,
        visible: false,
      },
      legend: false,
      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'percent',
        },
      },
      tooltip: {
        formatter: function () {
          var s =
            '<span class="bold" style="color:' +
            this.series.color +
            '">' +
            this.series.name +
            '</span>';
          s += '<br/>' + this.series.userOptions.percentage;
          return s;
        },
      },
      series: seriesOK,
    };
    let chart = Highcharts.chart(graf, this.options);
    this.loadLegend(seriesOK, graf);
     //Force a redraw of the chart to adjust the size to the container.
    setTimeout(() => {
      chart?.reflow();
    }, 0);

  }

  loadLegend(series: any, graf: string) {
    let legend = '';
    series.forEach((val, ind) => {
      let spanCircle = (val.color!== undefined)? 
      '<span class="circleList" style="background-color: '+ val.color +'"></span>':
      '<span class="circleList colorGrafBack-0' + ind + '"></span>';
      legend +=
        '<div class="flex-container-row itemLegend">' 
          + spanCircle + 
          '<span class="flex-item-grow-2">' + val.name + '</span>' +
          '<span class="flex-item-grow itemPerct">' + val.percentage + '</span>' +
        '</div>';
    });
    const safeLegendHtml = this.sanitizer.bypassSecurityTrustHtml(legend);
    switch (graf) {
      case 'grafCat':
        this.grafCatLegend = safeLegendHtml;
        break;
      case 'grafAssetType':
        this.grafAssetTypeLegend = safeLegendHtml;
        break;
      case 'grafCurrency':
        this.grafCurrencyLegend = safeLegendHtml;
      default:
        break;
    }
  }
}
